<div class="terms">
  <div class="content">
    <img 
      src="/assets/icons/back-arrow.svg" 
      alt="back btn" 
      (click)="onBackClick()"
      class="back-btn"
    />
    <h2 class="heading">Terms & Conditions</h2>
  </div>
  <p class="terms-para">Display terms and conditions here. Lorem ipsum dolor sit amet, 
    consectetur adipiscing elit. Integer mattis malesuada semper. 
    Vivamus et facilisis mauris. Sed eget lorem purus. 
    Integer cursus eleifend pharetra. 
    Etiam in ipsum ut sem sodales fermentum a id magna. 
    Quisque sit amet risus aliquet, dignissim lacus sit amet, ullamcorper mi. 
    Cras elementum lorem orci, vel egestas libero aliquet sed. 
    Cras ultricies felis nisi, ultrices tincidunt nulla elementum vel. 
    Suspendisse euismod ornare ante, id blandit eros ornare at.
  </p>

  <p class="terms-para">Pellentesque nec ante tempus, condimentum libero placerat, lobortis ante. 
    Sed vel enim id enim maximus auctor. Duis dignissim efficitur enim et pretium. 
    Mauris in ultricies nunc. Nullam lacus tellus, aliquam a faucibus in, 
    tincidunt ut enim. Pellentesque porta
  </p>
</div>

